import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from '@node-space/ui-components'
import {
  RewardsEmbeddedTabsEnum,
  useRewardsEmbeddedTabs,
} from 'pages/Rewards/hooks/useRewardsEmbeddedTabs'
import { RewardsEmbeddedCustomer } from './RewardsEmbeddedCustomer'

interface RewardsEmbeddedTabsProps {
  children: React.ReactNode
  showEmbeddedTabs: boolean
}

export const RewardsEmbeddedTabs = ({ children, showEmbeddedTabs }: RewardsEmbeddedTabsProps) => {
  const { t } = useTranslation()
  const { activeTab, handleChangeTab } = useRewardsEmbeddedTabs()

  const rewardsTabs = useMemo(
    (): Tab[] => [
      {
        header: t('rewards.tabs.myRewards'),
        id: RewardsEmbeddedTabsEnum.MY_REWARDS,
        content: null,
      },
      {
        header: t('rewards.tabs.customerRewards'),
        id: RewardsEmbeddedTabsEnum.CUSTOMER_REWARDS,
        content: null,
      },
    ],
    [t]
  )

  if (!showEmbeddedTabs) {
    return children
  }

  return (
    <>
      <Tabs defaultTabId={activeTab} tabs={rewardsTabs} onChange={handleChangeTab} />
      {activeTab === RewardsEmbeddedTabsEnum.MY_REWARDS && children}
      {activeTab === RewardsEmbeddedTabsEnum.CUSTOMER_REWARDS && <RewardsEmbeddedCustomer />}
    </>
  )
}
